import useSWRFetcher from "./fetcher";
import settings from "../../../constants/settings";
import { useCallback } from "react";
import {
  ParametersDict,
  ParametersHookData,
  ParametersResponse,
} from "../../../reducers/models/parameters";
import useSWRImmutable from "swr/immutable";

export const useParameters = () => {
  const transform = useCallback(async (response: Response) => {
    const parametersResponse = (await response.json()) as ParametersResponse;
    const parametersById = parametersResponse.parameters.reduce(
      (parametersDict, parameter) => {
        parametersDict[parameter.id] = parameter;
        return parametersDict;
      },
      {} as ParametersDict,
    );
    const parametersByShortName = parametersResponse.parameters.reduce(
      (parametersDict, parameter) => {
        parametersDict[parameter.short_name] = parameter;
        return parametersDict;
      },
      {} as ParametersDict,
    );
    return {
      parametersById,
      parametersByShortName,
    };
  }, []);

  const fetcher = useSWRFetcher<ParametersHookData>(transform);

  const { data } = useSWRImmutable<ParametersHookData, Error>(
    `${settings.api_url}/parts/parameters`,
    fetcher,
  );

  return data || null;
};
